export default function isValidNumber(input: any): input is number {
  return !!input && Number.isFinite(input);
}
